module.exports = __webpack_public_path__ + "static/img/SAD-1.11e8c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAD-1.jpg
// module id = IQLH
// module chunks = 0